import React from 'react';
import styles from './FJRetry.module.less';
import FJRetryIcon from '../../../assets/retry.svg?react';
import classNames from 'classnames';

interface FJRetryProps {
    refreshCallback?: (e: React.MouseEvent<HTMLDivElement>) => void;
    isShow?: boolean;
    className?: string;
}

const FJRetry: React.FC<FJRetryProps> = (
    { refreshCallback, isShow, className },
) => {
    const refresh = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        refreshCallback?.(e);
    };

    const boxCn = classNames(styles.box, { [styles.show]: isShow }, className);

    return isShow ? <div onClick={refresh} className={boxCn} >
        <FJRetryIcon className={styles.icon} />
    </div> : null;
};

export default FJRetry;
